module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/cvc-graphics-f81c0b94a6882ad3ab6cae1aaa268c67.png";